import {
  sceneBox,
  TutorialScene,
} from '@affine/core/components/tutorial-scene';
import {
  drawTrack,
  growTrack,
  popTrack,
  type SceneStory,
} from '@affine/core/components/tutorial-scene/scene-story';
import * as scene from '@affine/core/components/tutorial-scene/tutorial-scene.css';
import { CloudWorkspaceIcon } from '@blocksuite/icons/rc';
import clsx from 'clsx';

import * as styles from './storage-full-scene.css';

const SIZE = { width: 520, height: 156 };
const LOOP = 6400;
const OUT = 5600;
const DOC = { x: 52, y: 34, w: 136, h: 88 };
const CLOUD = { x: 316, y: 30, w: 152, h: 96 };
const ROWS = [400, 800, 1200];

const story: SceneStory = {
  loopMs: LOOP,
  tracks: [
    ...ROWS.map((at, index) => popTrack(`row-${index}`, LOOP, at, OUT)),
    popTrack('saved', LOOP, 1600, OUT),
    drawTrack('link', LOOP, 2000, OUT),
    growTrack('meter', LOOP, 2300, OUT, 'X'),
    popTrack('pause', LOOP, 2900, OUT),
  ],
};

/**
 * What a full workspace storage means: the changes are saved on this device,
 * the cloud has no room, so the transfer waits.
 */
export function StorageFullScene({ className }: { className?: string }) {
  return (
    <TutorialScene
      className={clsx(styles.stage, className)}
      height={SIZE.height}
      story={story}
      testId="storage-full-scene"
      width={SIZE.width}
    >
      <div className={scene.canvas} />
      <svg
        className={styles.links}
        viewBox={`0 0 ${SIZE.width} ${SIZE.height}`}
      >
        <path
          className={styles.link}
          d="M192 78 C238 78 268 78 312 78"
          data-scene-part="link"
          pathLength={1}
        />
      </svg>
      <div className={clsx(scene.box, scene.note)} style={sceneBox(DOC)}>
        <span
          className={clsx(scene.line, scene.heading)}
          style={{ width: '58%' }}
        />
        {ROWS.map((_, index) => (
          <span
            className={scene.line}
            data-scene-part={`row-${index}`}
            key={index}
            style={{ width: `${[100, 84, 66][index]}%` }}
          />
        ))}
        <span className={styles.saved} data-scene-part="saved">
          <svg className={styles.mark} viewBox="0 0 12 12">
            <path d="M2.6 6.2 5 8.5l4.4-5" />
          </svg>
        </span>
      </div>
      <span
        className={styles.pause}
        data-scene-part="pause"
        style={sceneBox({ x: 240, y: 66, w: 24, h: 24 })}
      >
        <svg className={styles.mark} viewBox="0 0 12 12">
          <path d="M4.4 3.4v5.2M7.6 3.4v5.2" />
        </svg>
      </span>
      <div className={clsx(scene.box, styles.cloud)} style={sceneBox(CLOUD)}>
        <CloudWorkspaceIcon className={styles.cloudIcon} />
        <span className={styles.meterTrack}>
          <span className={styles.meterFill} data-scene-part="meter" />
        </span>
      </div>
    </TutorialScene>
  );
}
